//'use strict';
import {Branding} from "../types/Branding";

{
    var app = angular.module('tf.profile', [])

        .controller('profileEditCtrl', ['$scope', '$http', 'userConfig', 'profile', 'demographics', function ($scope, $http, userConfig, profile, demographics) {
            $scope.profile = profile;

            $scope.demographics = {
                gender : null,
                ageGroup : null,
                equityExperience : null,
                derivativesExperience : null,
                country : null,
                state : null,
                postCode : null,
                sophisticatedOrWholesale: false
            };

            $scope.genders = [
                {key : 'M', value : 'Male'},
                {key : 'F', value : 'Female'}
            ];
            var genderMap = {};
            $scope.genders.forEach(function(gender) {
                genderMap[gender.key] = gender;
            });

            $scope.ageGroups = [
                {key : 'U25', value : '< 25'},
                {key : 'O25U35', value : '25 - 34'},
                {key : 'O35U45', value : '35 - 44'},
                {key : 'O45U55', value : '45 - 54'},
                {key : 'O55U65', value : '55 - 64'},
                {key : 'O65', value : '> 64'}
            ];
            var ageGroupMap = {};
            $scope.ageGroups.forEach(function(ageGroup) {
                ageGroupMap[ageGroup.key] = ageGroup;
            });

            $scope.experience = [
                {key : 'NONE', value : '< 1 year'},
                {key : 'BEGINNER', value : '1-3 years'},
                {key : 'INTERMEDIATE', value : '3-5 years'},
                {key : 'ADVANCED', value : '5+ years'},
                {key : 'PRO', value : 'Professional'}
            ];
            var experienceMap = {};
            $scope.experience.forEach(function(experience) {
                experienceMap[experience.key] = experience;
            });

            $scope.australia = {key : 'AUS', value : 'Australia'};
            $scope.countries = [
                $scope.australia,
                {key : 'NZL', value : 'New Zealand'},
                {key : 'GBR', value : 'United Kingdom'},
                {key : 'USA', value : 'United States'},
                {key : 'CHN', value : 'China'},
                {key : 'SGP', value : 'Singapore'},
                {key : 'HKG', value : 'Hong Kong'},
                {key : 'XXX', value : 'Other'}
            ];
            var countryMap = {};
            $scope.countries.forEach(function(country) {
                countryMap[country.key] = country;
            });

            $scope.demographics.stateKey = null;
            $scope.states = [
                {key : 'ACT', value : 'ACT'},
                {key : 'NSW', value : 'NSW'},
                {key : 'QLD', value : 'QLD'},
                {key : 'SA', value : 'SA'},
                {key : 'TAS', value : 'TAS'},
                {key : 'VIC', value : 'VIC'},
                {key : 'WA', value : 'WA'}
            ];
            var stateMap = {};
            $scope.states.forEach(function(state) {
                stateMap[state.key] = state;
            });

            $scope.demographics.gender = genderMap[demographics.gender];
            $scope.demographics.ageGroup = ageGroupMap[demographics.ageGroup];
            $scope.demographics.country = countryMap[demographics.country];
            $scope.demographics.state = stateMap[demographics.state];
            $scope.demographics.postCode = demographics.postCode;
            $scope.demographics.equityExperience = experienceMap[demographics.equityExperience];
            $scope.demographics.derivativesExperience = experienceMap[demographics.derivativesExperience];
            $scope.demographics.sophisticatedOrWholesale = demographics.sophisticatedOrWholesale;

            $scope.lastUpdated = demographics.lastUpdated;

            $scope.changePostCode = function() {
                if ($scope.demographics.postCode) {
                    $scope.demographics.country = $scope.australia;
                } else {
                    $scope.demographics.country = null;
                    $scope.demographics.state = null;
                    $scope.demographics.stateKey = null;
                }
            };

            $scope.$watch('demographics.stateKey', function(stateKey) {

            });

            $scope.onPostCodeState = function(state) {
                if (state) {
                    $scope.demographics.state = stateMap[state];
                } else {
                    $scope.demographics.state = null;
                }
            };

            $scope.changeState = function() {
                if ($scope.demographics.state) {
                    $scope.demographics.country = $scope.australia;
                } else {
                    $scope.demographics.country = null;
                }
            };

            $scope.changeCountry = function() {
                if ($scope.demographics.country != null && $scope.demographics.country == $scope.demographics.australia) {
                    $scope.demographics.postCode = null;
                    $scope.demographics.state = null;
                    $scope.demographics.stateKey = null;
                }
            };

            $scope.submitDemographics = function() {
                var form = this.demographicsForm;
                var demographics = {
                    gender : ($scope.demographics.gender ? $scope.demographics.gender.key : null),
                    ageGroup : ($scope.demographics.ageGroup ? $scope.demographics.ageGroup.key : null),
                    equityExperience : ($scope.demographics.equityExperience ? $scope.demographics.equityExperience.key : null),
                    derivativesExperience : ($scope.demographics.derivativesExperience ? $scope.demographics.derivativesExperience.key : null),
                    postCode : $scope.demographics.postCode,
                    state : ($scope.demographics.state ? $scope.demographics.state.key : null),
                    country : ($scope.demographics.country ? $scope.demographics.country.key : null),
                    sophisticatedOrWholesale: $scope.demographics.sophisticatedOrWholesale
                };

                $http.post('/tradefloor/api/user/demographics', demographics).then(function(response) {
                    $scope.lastUpdated = new Date();
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.submitContactForm = function() {
                var form = this.contactForm;

                $http.put('/tradefloor/api/user/' + userConfig.id + '/profile/contact', $scope.profile.contact).then(function(response) {
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.submitSocialForm = function() {
                var form = this.socialForm;

                $http.put('/tradefloor/api/user/' + userConfig.id + '/profile/social', $scope.profile.social).then(function(response) {
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.submitAddressForm = function() {
                var form = this.addressForm;

                $http.put('/tradefloor/api/user/' + userConfig.id + '/profile/address', $scope.profile.address).then(function(response) {
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.submitAboutForm = function() {
                var form = this.aboutForm;

                $http.put('/tradefloor/api/user/' + userConfig.id + '/profile/description', $scope.profile.about).then(function(response) {
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.submitDisclaimerForm = function() {
                var form = this.disclaimerForm;

                $http.put('/tradefloor/api/user/' + userConfig.id + '/profile/description', $scope.profile.disclaimer).then(function(response) {
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

        }])
        .controller('profileCtrl', ['$scope', '$state', '$http', '$stateParams', 'photoUpload', 'userConfig', function profileController($scope, $state, $http, $stateParams, photoUpload, userConfig) {

            $state.userConfig = userConfig;
        }])

        .controller('profileViewCtrl', ['$scope', '$state', '$http', '$stateParams', 'photoUpload', 'userConfig', 'profile', 'Map', '$window', '$timeout', function profileController($scope, $state, $http, $stateParams, photoUpload, userConfig, profile, Map, $window, $timeout) {

            $scope.userProfile = profile;
            $scope.demographics = {
                age: null,
                shares: null,
                options: null,
                ageTooltip : "Not Supplied",
                sharesTooltip : "Not supplied",
                optionsTooltip : "Not supplied"
            };

            $scope.place = {

            };

            $scope.openFacebook = function(){
                if ($scope.userProfile.social.facebook) {
                    var url = "https://www.facebook.com/" + $scope.userProfile.social.facebook;
                    $window.open(url);
                }
            };

            $scope.openTwitter = function(){
                if ($scope.userProfile.social.twitter) {
                    var url = "https://twitter.com/" + $scope.userProfile.social.twitter;
                    $window.open(url);
                }
            };

            $scope.openLinkedIn = function(){
                if ($scope.userProfile.social.linkedIn) {
                    var url = "https://www.linkedin.com" + $scope.userProfile.social.linkedIn;
                    $window.open(url);
                }
            };

            $scope.openWebsite = function(){
                if ($scope.userProfile.social.website) {
                    $window.open($scope.userProfile.social.website);
                }
            };

            if ($scope.userProfile.isAuthorizedRepresentative) {
                // Map.init();
            }

            $state.userConfig = userConfig;
            $scope.getUserDemographics = function() {
                $http.get('/tradefloor/api/user/demographics/' + $stateParams.userId).then(function (response) {
                    var data = response.data;
                    $scope.userDemographics = data;
                    if ($scope.userDemographics.equityExperience) {
                        if ($scope.userDemographics.equityExperience == "NONE") {
                            $scope.demographics.shares = 1;
                            $scope.demographics.sharesTooltip = "< 1 year"
                        } else if ($scope.userDemographics.equityExperience == "BEGINNER") {
                            $scope.demographics.shares = 2;
                            $scope.demographics.sharesTooltip = "1 - 3 years"
                        } else if ($scope.userDemographics.equityExperience == "INTERMEDIATE") {
                            $scope.demographics.shares = 3;
                            $scope.demographics.sharesTooltip = "3 - 5 years"
                        } else if ($scope.userDemographics.equityExperience == "ADVANCED") {
                            $scope.demographics.shares = 4;
                            $scope.demographics.sharesTooltip = "5 + years"
                        } else if ($scope.userDemographics.equityExperience == "PRO") {
                            $scope.demographics.shares = 5;
                            $scope.demographics.sharesTooltip = "Professional"
                        }
                    }

                    if ($scope.userDemographics.derivativesExperience) {
                        if ($scope.userDemographics.derivativesExperience == "NONE") {
                            $scope.demographics.options = 1;
                            $scope.demographics.optionsTooltip = "< 1 year"
                        } else if ($scope.userDemographics.derivativesExperience == "BEGINNER") {
                            $scope.demographics.options = 2;
                            $scope.demographics.optionsTooltip = "1 - 3 years"
                        } else if ($scope.userDemographics.derivativesExperience == "INTERMEDIATE") {
                            $scope.demographics.options = 3;
                            $scope.demographics.optionsTooltip = "3 - 5 years"
                        } else if ($scope.userDemographics.derivativesExperience == "ADVANCED") {
                            $scope.demographics.options = 4;
                            $scope.demographics.optionsTooltip = "5 + years"
                        } else if ($scope.userDemographics.derivativesExperience == "PRO") {
                            $scope.demographics.options = 5;
                            $scope.demographics.optionsTooltip = "Professional"
                        }
                    }

                    if ($scope.userDemographics.ageGroup) {
                        if ($scope.userDemographics.ageGroup == "U25") {
                            $scope.demographics.age = 1;
                            $scope.demographics.ageTooltip = "Under 25"
                        } else if ($scope.userDemographics.ageGroup == "O25U35") {
                            $scope.demographics.age = 2;
                            $scope.demographics.ageTooltip = "25-35"
                        } else if ($scope.userDemographics.ageGroup == "O35U45") {
                            $scope.demographics.age = 3;
                            $scope.demographics.ageTooltip = "35-45"
                        } else if ($scope.userDemographics.ageGroup == "O45U55") {
                            $scope.demographics.age = 4;
                            $scope.demographics.ageTooltip = "45-55"
                        } else if ($scope.userDemographics.ageGroup == "O55U65" || $scope.userDemographics.ageGroup == "O65") {
                            $scope.demographics.age = 5;
                            $scope.demographics.ageTooltip = "55 +"
                        }
                    }

                });
            };

            $scope.getUserDemographics();

            $scope.deltaOptions = {
                chart: {
                    type: 'discreteBarChart',
                    height: 450,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 50,
                        left: 55
                    },
                    x: function(d){return d.label;},
                    y: function(d){return d.value + (1e-10);},
                    showValues: true,
                    valueFormat: function(d){
                        return d3.format(',.4f')(d);
                    },
                    duration: 500,
                    xAxis: {
                        axisLabel: 'Stock'
                    },
                    yAxis: {
                        axisLabel: 'Net Delta',
                        axisLabelDistance: -10
                    }
                }
            };

            function barColour(percent) {
                percent = Math.min(percent, 1);
                return "hsl(" + Math.round(120 * (1 - percent)) + ", 70%, 45%)";
            }


            $scope.getPortfolios = function () {
                    $http.get('/tradefloor/api/portfolio/exposure/' + $stateParams.userId).then(function(response){
                        var data = response.data;
                        $scope.portfolios = data;
                        $scope.portfolios.forEach(function(p){
                            p.clientPortfolioSummary.totalPnL = p.clientPortfolioSummary.nlv - 100000;
                            p.clientPortfolioSummary.utilisation = (p.clientPortfolioSummary.totalCash + p.clientPortfolioSummary.totalCollateral) == 0 ? 0 : p.clientPortfolioSummary.clientMargin / (p.clientPortfolioSummary.totalCash + p.clientPortfolioSummary.totalCollateral);
                            p.clientPortfolioSummary.utilisationClamped = Math.min(100, p.clientPortfolioSummary.utilisation * 100);
                            p.clientPortfolioSummary.utilisationLevel = barColour(p.clientPortfolioSummary.utilisation);
                            p.clientPortfolioSummary.weekPnlChange = p.clientPortfolioSummary.pnl - p.clientPortfolioSummary.weekPnl;

                            var deltaValues = [];

                            p.combinedCommodities.forEach(function (cc) {
                                var deltaEntry = {
                                    "label" : cc.security,
                                    "value" : cc.netDelta
                                };
                                deltaValues.push(deltaEntry)
                            });
                            p.deltaData = [
                                {
                                    key: "Net Delta",
                                    values : deltaValues
                                }
                            ];
                        });
                    })
            };

            $scope.getPortfolios();

            // Track if data is new
            $scope.lastCommentId = null;
            $scope.lastPostId = null;

            $scope.summary = true;

            $scope.post = {
                summary : null,
                promise : null
            };

            $scope.posts = [];
            $scope.lastCommentId = null;
            $scope.unallocatedComments = [];

            $scope.likePromise = null;

            $scope.likePost = function(post) {
                if (post.likePromise != null) {
                    return;
                }

                if (post.liked) {
                    post.likePromise = $http.delete('/tradefloor/api/posts/' + post.id + '/like').then(function(result) {
                        post.liked = !post.liked;
                        post.likes = post.likes - 1;

                    }).finally(function() {
                        post.likePromise = null;
                    });
                } else {
                    post.likePromise = $http.put('/tradefloor/api/posts/' + post.id + '/like').then(function(result) {
                        post.liked = !post.liked;
                        post.likes = post.likes + 1;
                    }).finally(function() {
                        post.likePromise = null;
                    });
                }
            };


            $scope.toggleEditComment = function(comment) {
                comment.editing = !comment.editing;
                comment.summaryInput = comment.summary;
                // Hack to ensure the UI has updated and there is an element to focus on
                $timeout(function() {
                    var field = angular.element(document.getElementById('commentUpdate' + comment.id));
                    field.focus();
                }, 0);
            };

            $scope.showMoreComments = function(post) {
                post.limit += 5;
            };

            $scope.loadNewPosts = function() {

                    $http.get('/tradefloor/api/posts/by/' + $stateParams.userId, {ignoreLoadingBar : true}).then(function(response) {
                        var posts = response.data;

                        posts.forEach(function(post) {
                            post.comments = [];
                            post.limit = 2;
                        });

                        $scope.posts = posts;

                        $scope.loadNewComments();
                    });
            };

            $scope.loadNewPosts();

            $scope.maybeCancelUpdate = function($event, post, comment, updateCommentForm) {
                if (event.which == 27) {
                    $scope.cancelUpdate(post, comment, updateCommentForm);
                }
            };

            $scope.cancelUpdate = function(post, comment, updateCommentForm) {
                updateCommentForm.$setPristine();
                updateCommentForm.$setUntouched();

                comment.editing = false;
                comment.summaryInput = undefined;
            };
            $scope.updateComment = function(post, comment) {
                var form = this.updateCommentForm;
                if (form.$invalid) {
                    return;
                }

                comment.editing = false;

                $http.post('/tradefloor/api/posts/' + post.id + '/comments/' + comment.id, comment.summaryInput).then(function() {
                    comment.summary = comment.summaryInput;
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.deleteComment = function(post, comment) {
                $http.delete('/tradefloor/api/posts/' + post.id + '/comments/' + comment.id).then(function() {
                    post.comments = post.comments.filter(function(c) {
                        return c != comment;
                    });
                });
            };

            $scope.commentOnPost = function(post) {
                var form = this.commentForm;
                if (form.$invalid) {
                    return;
                }

                $http.put('/tradefloor/api/posts/' + post.id + '/comments', post.comment).then(function() {

                    $scope.loadNewComments();

                    post.comment = null;
                    form.$setPristine();
                    form.$setUntouched();
                });
            };

            $scope.loadNewComments = function() {

                $http.get('/tradefloor/api/posts/comments' + ($scope.lastCommentId ? '?since=' + $scope.lastCommentId : ''), {ignoreLoadingBar : true}).then(function(response) {
                    var comments = response.data;

                    if (!comments.length) {
                        return;
                    }

                    $scope.lastCommentId = comments[0].id;

                    comments.reverse();

                    var postsById = {};

                    $scope.comments = comments.concat(comments);

                    $scope.unallocatedComments.forEach(function(comment) {
                        var post = postsById[comment.postId];
                        if (!post) {

                            $scope.posts.forEach(function(p) {
                                if (p.id == comment.postId) {
                                    post = p;
                                }
                            });

                            if (post) {
                                postsById[post.id] = post;
                            }
                        }

                        if (post) {
                            comment.post = post;
                            post.comments.unshift(comment);
                        }
                    });

                    $scope.unallocatedComments = $scope.unallocatedComments.filter(function (comment) {
                        return comment.post === undefined;
                    });

                    comments.forEach(function(comment) {
                        var post = postsById[comment.postId];
                        if (!post) {

                            $scope.posts.forEach(function(p) {
                                if (p.id == comment.postId) {
                                    post = p;
                                }
                            });

                            if (post) {
                                postsById[post.id] = post;
                            }
                        }

                        if (post) {
                            post.comments.unshift(comment);
                            comment.post = post;
                        } else {
                            $scope.unallocatedComments.unshift(comment);
                        }

                    });

                });
            };

        }])

        .controller('billingCtrl', ['$scope', '$state', '$http', '$stateParams', 'userConfig', 'billing', 'subscriptions', "confirmationService", "currentUserService", "$uibModal",
            function billingController($scope, $state, $http, $stateParams, userConfig, billing, subscriptions, confirmationService, currentUserService, $uibModal) {
            $scope.subscriptions = subscriptions;
            $scope.billingDetails = billing;
            $scope.radioModel = 'Billing';

            $scope.cancelling = false;

            $scope.cancelSubscription = async (subscription) => {
                $scope.cancelling = true;

                try {
                    if (currentUserService.isBranding(Branding.IV)) {
                        await showIvCancelInstructions();
                    } else {
                        await cancelNow(subscription);
                    }
                } finally {
                    $scope.cancelling = false;
                }
            };

            $scope.cardUpdated = (card) => {
                $scope.billingDetails.card = card;
            };

            async function showIvCancelInstructions(subscription) {
                const modalInstance = $uibModal.open({
                        template: `
<div class="modal-header">
    <h4>
        Sorry to see you go
    </h4>
</div>
        
<div class="modal-body">
    Please contact accounts <a href="mailto:accounts@impliedvolatility.com.au?subject=Cancel%20My%20Account">accounts@impliedvolatility.com.au</a> to cancel your subscription
</div>

<div class="modal-footer">
    <button class="btn btn-md btn-default" ng-click="$close()">OK</button>
</div>
`
                    });

                await modalInstance.result;
            }

            async function cancelNow(subscription) {
                await confirmationService.open("Are you sure you wish to cancel your subscription?");
                await $http.delete("/tradefloor/api/stripe/subscription/" + subscription.id);
                $scope.subscriptions = $scope.subscriptions.filter((s) => s.id !== subscription.id);
                currentUserService.refreshConfig();

            }
        }])

        .controller('profileBrokerViewCtrl', ['$scope', 'Map', '$state', '$http', '$stateParams', 'photoUpload', 'userConfig', function profileController($scope, Map, $state, $http, $stateParams, photoUpload, userConfig) {
            $scope.place = {

            };

            Map.init();

            }]);

}
